import React, { useEffect, useState } from 'react';
interface HeroProps {
  openModal: () => void;
}
export function Hero({
  openModal
}: HeroProps) {
  const [isVisible, setIsVisible] = useState(false);
  const [mousePosition, setMousePosition] = useState({
    x: 0,
    y: 0
  });
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 300);
    const handleMouseMove = (e: MouseEvent) => {
      setMousePosition({
        x: e.clientX / window.innerWidth,
        y: e.clientY / window.innerHeight
      });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);
  return <div className="relative w-full min-h-screen flex items-center justify-center overflow-hidden" data-id="element-108">
      {/* Ambient background with parallax effect */}
      <div className="absolute inset-0 z-0 transition-all duration-1000 ease-out" style={{
      transform: `translate(${mousePosition.x * -20}px, ${mousePosition.y * -20}px)`,
      filter: 'blur(80px)'
    }} data-id="element-109">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-mint-400/20 dark:bg-mint-500/10 rounded-full" data-id="element-110" />
        <div className="absolute bottom-1/4 right-1/4 w-72 h-72 bg-mint-500/10 dark:bg-mint-400/10 rounded-full" data-id="element-111" />
      </div>
      {/* Content */}
      <div className={`relative z-20 w-full max-w-3xl mx-auto px-6 transition-opacity duration-1000 ease-out text-center ${isVisible ? 'opacity-100' : 'opacity-0'}`} data-id="element-112">
        <h1 className="font-light text-4xl md:text-6xl lg:text-7xl tracking-tight leading-none mb-8" data-id="element-113">
          <span className="block mb-2" data-id="element-114">stop guessing.</span>
          <span className="block text-mint-600 dark:text-mint-400" data-id="element-115">
            start eating smart.
          </span>
        </h1>
        <p className="text-black/60 dark:text-white/60 text-lg md:text-xl leading-relaxed mb-4 max-w-2xl mx-auto" data-id="element-116">
          caltalk finds restaurants that match your macros—so you can eat out
          without the guilt.
        </p>
        <p className="text-black/50 dark:text-white/50 text-base leading-relaxed mb-12 max-w-2xl mx-auto" data-id="element-117">
          personalized nutrition + ai chat + local restaurants = your perfect
          meal, every time.
        </p>
        <button onClick={openModal} className="px-8 py-4 bg-transparent backdrop-blur-sm border border-black/10 dark:border-white/10 rounded-full text-sm font-light hover:border-mint-500 dark:hover:border-mint-400 hover:text-mint-600 dark:hover:text-mint-400 transition-all duration-300 group" data-id="element-118">
          <span className="relative inline-block" data-id="element-119">
            join the waitlist
            <span className="absolute bottom-0 left-0 w-0 h-px bg-mint-500 dark:bg-mint-400 group-hover:w-full transition-all duration-300" data-id="element-120"></span>
          </span>
        </button>
      </div>
      {/* Scroll indicator */}
      <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2" data-id="element-121">
        <div className="w-6 h-10 border border-black/20 dark:border-white/20 rounded-full flex justify-center" data-id="element-122">
          <div className="w-1.5 h-1.5 bg-black/40 dark:bg-white/40 rounded-full mt-2 animate-bounce" data-id="element-123" />
        </div>
      </div>
    </div>;
}